export var ExpandedState = /*#__PURE__*/function (ExpandedState) {
  /* The group is collapsed and should only render the most recent notification */
  ExpandedState[ExpandedState["Collapsed"] = 0] = "Collapsed";
  /* The group is expanded but there are still more notifications to fetch within the group */
  ExpandedState[ExpandedState["Open"] = 1] = "Open";
  /* The group is expanded and all notifications have been fetched*/
  ExpandedState[ExpandedState["Complete"] = 2] = "Complete";
  return ExpandedState;
}({});